export interface IAddressDataValidation {
    addressType: boolean,
    label: boolean,
    addressLine1: boolean,
    city: boolean,
    stateId: boolean,
    postalCode: boolean,
    firstName: boolean,
    lastName: boolean,
    shipToPhoneNumber: boolean
}

export const initialValidation: IAddressDataValidation = {
    addressType: true,
    addressLine1: true,
    city: true,
    stateId: true,
    postalCode: true,
    label: true,
    firstName: true,
    lastName: true,
    shipToPhoneNumber: true
}